import { resolveComponent as _resolveComponent, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "modal-wrap"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DeliveryDatePickerInner = _resolveComponent("DeliveryDatePickerInner")!
  const _component_AsahiArrow = _resolveComponent("AsahiArrow")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(), _createBlock(_component_DeliveryDatePickerInner, _mergeProps({ ref: "datePickerInnerRef" }, _ctx.$attrs, {
      key: _ctx.componentKey,
      modelValue: _ctx.modelValue,
      shipmentId: _ctx.shipmentId,
      holidayDays: _ctx.holidayDays,
      shipToId: _ctx.shipToId,
      "is-mobile": _ctx.isMobile,
      class: _ctx.isDatePickerOpened? 'rotated' : '',
      changeCalenderBgColor: _ctx.changeCalenderBgColor,
      onDatePickerOpen: _ctx.onDatePickerOpened,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = (value) => _ctx.$emit('update:modelValue', value))
    }), null, 16, ["modelValue", "shipmentId", "holidayDays", "shipToId", "is-mobile", "class", "changeCalenderBgColor", "onDatePickerOpen"])),
    (_ctx.hasArrow)
      ? (_openBlock(), _createBlock(_component_AsahiArrow, {
          key: 0,
          class: "arrow-container-date-deliver",
          "is-rotated": !_ctx.arrowRotated,
          arrowColor: "black",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.openTheDatePicker()))
        }, null, 8, ["is-rotated"]))
      : _createCommentVNode("", true),
    ( _ctx.isMobile && _ctx.isDatePickerOpened)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1))
      : _createCommentVNode("", true)
  ], 64))
}